import { useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../../CustomHooks/useApi";
import useRDService from "../../../../CustomHooks/useRDService";
import DeviceStatus from "../../NewAeps/DeviceStatus";
import VimoApForm2 from "./VimoApForm2";

const VimoApIntegration2 = () => {

  const { device, captureFingerprint, loading } = useRDService();

  const merchantdetails = useSelector((state) => state.auth?.employeeDetails);
  const { lat, lng }    = useSelector((state) => state.location);

  const [processing, setProcessing] = useState(false);

  const username  = merchantdetails?.username;
  const latitude  = lat;
  const longitude = lng;

  const { callApi: aadhaarPayApi } = useApi("/aeps/vimopay/transaction-from-user", "POST");
  const { callApi: otpApi }        = useApi("/aeps/vimopay/transaction-otp-from-user", "POST");

  const [popup, setPopup] = useState({
    show: false, title: "", message: "", type: "",
  });

  const [previousData, setPreviousData]         = useState(null);
  const [clearFormTrigger, setClearFormTrigger] = useState(0);

  const [otpPopup, setOtpPopup] = useState({
    show: false, otp: "", apAuthTxnId: "", pendingFormData: null, submitting: false,
  });

  const [ip, setIp]           = useState("");
  const [ipFetched, setIpFetched] = useState(false);

  const getIp = async () => {
    if (ipFetched) return ip;
    try {
      const d = await fetch("https://api.ipify.org?format=json").then((r) => r.json());
      setIp(d.ip || "");
      setIpFetched(true);
      return d.ip || "";
    } catch {
      setIpFetched(true);
      return "";
    }
  };

  const deviceType = (device || "mantra").toLowerCase().replace(/[^a-z]/g, "");

  const showResult = (title, message, type = "") =>
    setPopup({ show: true, title, message, type });

  const closePopup = () => {
    if (popup.show) setClearFormTrigger((p) => p + 1);
    setPopup({ show: false, title: "", message: "", type: "" });
  };

  // ── OTP confirm → fingerprint → AP transaction ────────────────────────────
  const handleOtpSubmit = async () => {
    const formData = otpPopup.pendingFormData;
    try {
      setOtpPopup((p) => ({ ...p, submitting: true }));
      setProcessing(true);

      const pidXml = await captureFingerprint("", otpPopup.otp);
      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setOtpPopup({ show: false, otp: "", apAuthTxnId: "", pendingFormData: null, submitting: false });
        setProcessing(false);
        showResult("Failed", "Fingerprint Capture Failed");
        return;
      }

      const currentIp = await getIp();

      const response = await aadhaarPayApi({
        mid: username,
        transactionType: "AP",
        amount: String(formData.amount),
        bankIIN: (formData?.bank?.iin || "").replace(/\s+/g, ""),
        ipAddress: currentIp,
        deviceType,
        latitude: latitude?.toString() || "0",
        longitude: longitude?.toString() || "0",
        pidData: pidXml,
        cwAuthTxnId: otpPopup.apAuthTxnId,
        adhaarNumber: formData.aadhaar,
        mobileNumber: formData.mobile,
      });

      setOtpPopup({ show: false, otp: "", apAuthTxnId: "", pendingFormData: null, submitting: false });
      setProcessing(false);

      if (response?.status === "000") {
        showResult(
          "Aadhaar Pay Successful",
          `Amount : ₹${response?.transactionAmount}

Avl Balance: ₹${response?.availableBalance}

Bank RRN : ${response?.rrn}
Aadhaar No : ${response?.aadhaarNo}
Date : ${response?.txnDateTime}`,
          "success"
        );
      } else {
        showResult("Failed", response?.npciMessage || "Transaction Failed");
      }
    } catch (err) {
      setOtpPopup((p) => ({ ...p, submitting: false }));
      setProcessing(false);
      showResult("Error", err?.message || "Transaction Failed");
    }
  };

  // ── Main AP handler ───────────────────────────────────────────────────────
  const handleCapture = async (formData) => {
    try {
      setProcessing(true);
      setPreviousData({ ...formData });

      const currentIp = await getIp();

      // OTP gate for AP > ₹5,000
      if (Number(formData.amount) > 5000) {
        const otpRes = await otpApi({
          mid: username,
          bankIIN: (formData?.bank?.iin || "").replace(/\s+/g, ""),
          transactionType: "APTFA",
          amount: `${Number(formData.amount).toFixed(4)}`,
          latitude: latitude?.toString() || "0",
          longitude: longitude?.toString() || "0",
          ipAddress: currentIp,
          appPlatform: "android",
          appVersion: "1.0.0",
          adhaarNumber: formData.aadhaar,
          mobileNumber: formData.mobile,
        });

        if (otpRes?.status === "000") {
          setOtpPopup({
            show: true,
            otp: "",
            apAuthTxnId: otpRes?.txnRefId || "",
            pendingFormData: formData,
            submitting: false,
          });
          setProcessing(false);
          return;
        }
        // OTP step failed
        setProcessing(false);
        showResult("Failed", otpRes?.npciMessage || "OTP request failed");
        return;
      }

      // Direct AP (≤ ₹5,000)
      const pidXml = await captureFingerprint("");
      if (!pidXml || !pidXml.includes('errCode="0"')) {
        setProcessing(false);
        showResult("Failed", "Fingerprint Capture Failed");
        return;
      }

      const response = await aadhaarPayApi({
        mid: username,
        transactionType: "AP",
        amount: String(formData.amount),
        bankIIN: (formData?.bank?.iin || "").replace(/\s+/g, ""),
        ipAddress: currentIp,
        deviceType,
        latitude: latitude?.toString() || "0",
        longitude: longitude?.toString() || "0",
        pidData: pidXml,
        adhaarNumber: formData.aadhaar,
        mobileNumber: formData.mobile,
      });

      setProcessing(false);

      if (response?.status === "000") {
        showResult(
          "Aadhaar Pay Successful",
          `Amount : ₹${response?.transactionAmount}

Avl Balance: ₹${response?.availableBalance}

Bank RRN : ${response?.rrn}
Aadhaar No : ${response?.aadhaarNo}
Date : ${response?.txnDateTime}`,
          "success"
        );
      } else {
        showResult("Failed", response?.npciMessage || "Transaction Failed");
      }

    } catch (err) {
      setProcessing(false);
      showResult("Error", err?.message || "Transaction Failed");
    }
  };

  return (
    <div>

      <DeviceStatus device={device} />

      <VimoApForm2
        onSubmit={handleCapture}
        processing={processing}
        loading={loading}
        previousData={previousData}
        clearFormTrigger={clearFormTrigger}
      />

      {/* OTP popup — AP > ₹5,000 */}
      {otpPopup.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl shadow-2xl p-8 w-[420px] text-center">

            <h2 className="text-2xl font-semibold">Enter OTP</h2>

            <p className="mt-3 text-[15px] text-gray-500 leading-6">
              An OTP has been sent to the customer's Aadhaar-registered mobile number.
              Enter the OTP below, then place the finger on the scanner.
            </p>

            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={otpPopup.otp}
              onChange={(e) =>
                setOtpPopup((p) => ({ ...p, otp: e.target.value.replace(/\D/g, "") }))
              }
              placeholder="• • • • • •"
              className="mt-6 w-full border-2 border-gray-300 rounded-xl px-4 py-4 text-3xl tracking-[0.5em] text-center font-mono focus:outline-none focus:border-blue-500"
            />

            <div className="mt-6 flex gap-3">
              <button
                onClick={() =>
                  setOtpPopup({ show: false, otp: "", apAuthTxnId: "", pendingFormData: null, submitting: false })
                }
                disabled={otpPopup.submitting}
                className="flex-1 border-2 border-gray-300 text-gray-600 py-3 rounded-xl font-semibold hover:bg-gray-50 disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                onClick={handleOtpSubmit}
                disabled={otpPopup.otp.length < 4 || otpPopup.submitting}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold disabled:opacity-50"
              >
                {otpPopup.submitting ? "Processing…" : "Submit & Scan"}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Result popup */}
      {popup.show && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl shadow-2xl p-6 w-[420px] text-center">

            <h2 className={`text-2xl font-semibold ${popup.type === "success" ? "text-green-600" : "text-gray-800"}`}>
              {popup.title}
            </h2>

            <p className="mt-5 whitespace-pre-line text-[18px] font-bold text-gray-700 leading-8">
              {popup.message}
            </p>

            <button
              onClick={closePopup}
              className="mt-6 bg-blue-600 hover:bg-blue-700 text-white px-10 py-3 rounded-xl"
            >
              OK
            </button>

          </div>
        </div>
      )}

    </div>
  );
};

export default VimoApIntegration2;
